// extracted by mini-css-extract-plugin
export default {"productDescription":"dfa-z","featuredDescription":"efa-z","description":"ffa-z","more":"gfa-z","descriptionSku":"hfa-z"};